// Features: M004-F0720. Tests: T-M004-0225 (correction form, W9), T-M004-0206 (the drawer mounts it).
//
// "Bill more under TX-xxxxxxxx" on a WRITTEN transaction (design M004-F0712-F0716 section 4.6a, ACCT-TX-016), mounted from the history
// drawer's action row. It is the SAME correction form the customer page owns (ledgerMoves/MoveControls BillByHandForm, correction
// mode) driven by the SAME write engine (ledgerMoves/useLedgerMoves.billByHand): one Idempotency-Key per intent, a synchronous
// double-click guard, step-up through StepUpDialog, a CONFIRMED UI (the sentence appears only from the Ledger's answer). The write goes
// to the Ledger only; the drawer then re-reads the history so the `correction` child and the `corrected` event appear.
import React, { useMemo } from 'react';
import useLedgerMoves from '../ledgerMoves/useLedgerMoves';
import { BillByHandForm, MoveStatus } from '../ledgerMoves/MoveControls';

const NO_LINES = Object.freeze({ lines: [] });

function poundsFormatter() {
  return (value, currency) => {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(value); } catch { return String(value); }
  };
}

export default function TxBillMore({ orgId, userId, handOffId, description, customerName, onDone }) {
  const money = useMemo(poundsFormatter, []);
  // No queue page is mounted behind the drawer: the answer's queue state is not applied anywhere; the drawer re-reads the TX history.
  const moves = useLedgerMoves({ orgId, userId, money, draft: NO_LINES, applyState: () => {}, reload: onDone, enabled: true });
  const item = { handOffId, description: description || '' };
  if (!moves.canMove(item)) return null;
  const open = moves.panel?.kind === 'hand' && moves.panel.id === handOffId;
  return (
    <div data-testid="tx-bill-more">
      {open
        ? <BillByHandForm item={item} moves={moves} customerName={customerName} correction />
        : <button type="button" className="tx-link-button" data-testid="tx-bill-more-open" disabled={moves.busy}
          onClick={() => moves.openPanel({ kind: 'hand', id: handOffId })}>Bill more under this transaction</button>}
      <MoveStatus moves={moves} scope="advice" />
      {moves.dialog}
    </div>
  );
}
